import { useEffect, useState } from "react";
import { useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import { ProductViewContainer } from "./styled";
import Images from "./productView/images";
import Info from "./productView/info";
import { findTargetMenuName } from "../../common/function/shopping";
import MediaViewer from "../../../../common/mediaViewer";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useModal } from "../../../../hooks/useModal";

export default function ProductView({ product, options, setOptions }) {
  const navigate = useNavigate();
  const location = useLocation();

  const { url, theme, menus, homepageInfo, cmpnyNo } = useOutletContext();

  const user = useSelector((state) => state?.user?.data[0]);

  const [amount, setAmount] = useState(1);
  const [isDetail, setIsDetail] = useState(false);
  const [images, setImages] = useState([]);

  const searchQuery = location?.state?.keyword || "";
  const selectedQuery = location?.state?.selected;
  const pageQuery = location?.state?.page || 0;
  const moveToUrl = searchQuery
    ? `/shop/${url}/search?keyword=${searchQuery}`
    : `/shop/${url}/productsList?code=${selectedQuery?.code || ""}&brand=${
        selectedQuery?.brand || ""
      }&page=${pageQuery}`;

  const { modal, openModal, closeModal } = useModal();

  const updateCount = (increment = true) => {
    setAmount((prevCount) => (increment ? prevCount + 1 : Math.max(prevCount - 1, 1)));
  };

  // 바로구매 버튼 클릭
  const handleCheckout = () => {
    if (!validationCheck()) return;

    let imageUrl = "";
    try {
      const parsed = JSON.parse(product.productImageUrl || "[]");
      imageUrl = parsed[0] || "";
    } catch {
      imageUrl = product.productImageUrl || "";
    }

    const productInfo = {
      cmpnyNo: cmpnyNo,
      cmpnyNm: homepageInfo?.cmpnyNm,
      products: [
        {
          vendorProductId: parseInt(product.id, 10),
          productName: product.name,
          productPrice: product.price,
          productImageUrl: imageUrl,
          quantity: amount,
          checked: true,
          options: options
            .filter((group) => group.selection && group.selection !== "not")
            .map((group) => {
              const selected = group.options.find(
                (opt) => String(opt.id) === String(group.selection),
              );
              return {
                optionGroupName: group.name,
                optionId: selected.id,
                qty: selected?.consumeCount || 1,
                name: selected?.value || "",
                price: selected?.addPrice || 0,
              };
            }),
        },
      ],
    };

    sessionStorage.setItem("orderItems", JSON.stringify([productInfo]));
    navigate(`/shop/mypage/order`);
  };

  // 장바구니 담기
  const handleCart = async () => {
    if (!validationCheck()) return;

    const productInfo = buildProductInfo();
    const result = user ? await updateCart(productInfo) : localUpdate(productInfo);

    if (result) {
      openModal({
        type: "confirmation",
        title: "장바구니 이동",
        message: ["상품이 장바구니에 담겼습니다.", "장바구니로 이동하시겠습니까?"],
        handleConfirm: () => navigate(`/shop/mypage/cart`),
        handleCancel: closeModal,
      });
    }
  };

  // 필수 옵션 체크
  const validationCheck = () => {
    if (!product.price) {
      toast.error("해당 상품은 장바구니에 담을 수 없습니다.");
      console.log(product);
      return false;
    }
    for (const group of options) {
      if (group.isRequired && (!group.selection || group.selection === "not")) {
        toast.error(`옵션 ${chooseParticle(group.name, "을를")} 선택해주세요.`);
        return false;
      }
    }
    return true;
  };

  // 장바구니 상품 정보 생성
  const buildProductInfo = () => {
    const productInfo = {
      vendorProductId: parseInt(product.id, 10),
      quantity: amount,
      checked: true,
    };

    const selectedOptions = options
      .filter((group) => group.selection && group.selection !== "not")
      .map((group) => {
        const selected = group.options.find((opt) => String(opt.id) === String(group.selection));

        console.log(selected);
        return {
          optionGroupName: group.name,
          optionId: selected.id,
          qty: selected?.consumeCount || 1,
          name: selected?.value || "",
          price: selected?.addPrice || 0,
        };
      });

    if (selectedOptions.length > 0) productInfo.options = selectedOptions;
    else productInfo.options = [];

    return productInfo;
  };

  // 로컬스토리지 업데이트
  const localUpdate = (productInfo) => {
    const local = JSON.parse(localStorage.getItem("cart")) || [];

    const isSameOptions = (opts1 = [], opts2 = []) => {
      if (opts1.length !== opts2.length) return false;
      const sorted1 = [...opts1].sort((a, b) => a.optionId - b.optionId);
      const sorted2 = [...opts2].sort((a, b) => a.optionId - b.optionId);
      return sorted1.every(
        (opt, i) => opt.optionId === sorted2[i].optionId && opt.qty === sorted2[i].qty,
      );
    };

    const existing = local.find(
      (item) =>
        item.vendorProductId === productInfo.vendorProductId &&
        isSameOptions(item.options, productInfo.options),
    );

    if (existing) {
      existing.quantity += productInfo.quantity;
    } else {
      local.push(productInfo);
    }

    localStorage.setItem("cart", JSON.stringify(local));
    return true;
  };

  // 서버 장바구니 업데이트
  const updateCart = async (product) => {
    const body = {
      input: {
        mberNo: user.mberNo,
        platform: "MULTI_PAGE",
        ...product,
      },
    };

    try {
      const res = await axios.post("/erp/cart/upsert", body);
      return res.status === 200;
    } catch {
      return false;
    }
  };

  const clickImage = (src) => {
    if (!src) return;

    const index = product.media.findIndex((ele) => ele === src);
    const reorderedImages = [...product.media.slice(index), ...product.media.slice(0, index)];
    setImages(reorderedImages);
    setIsDetail(true);
  };

  return (
    <>
      {modal}
      {/* {isDetail && <MediaViewer files={images} setIsOpen={setIsDetail} />} */}
      <ProductViewContainer className={`theme-${theme}`}>
        <h3>
          <span>{findTargetMenuName(menus, 1)}</span>
        </h3>
        <button className="nav" onClick={() => navigate(`/shop/${url}/productsList`)}>
          전체 제품 보기
        </button>
        <div className="product">
          <Images media={product?.media} clickImage={clickImage} />
          <Info
            product={product}
            amount={amount}
            updateCount={updateCount}
            options={options}
            setOptions={setOptions}
            handleCart={handleCart}
            handleCheckout={handleCheckout}
          />
        </div>
        <h3>
          <span>상세</span>
        </h3>
        <div className="details">
          {/* <img src="/img/shop_delivery_infomation.jpg" alt="shop delivery infomation" /> */}
          <div
            dangerouslySetInnerHTML={{
              __html: product?.description
                ? product.description.replace(
                    /<img\s+[^>]*src=["'](cdn\/[^"']+)["'][^>]*>/g,
                    (match, src) => `<img src="${imgHandler(src)}">`,
                  )
                : "" || "",
            }}></div>
        </div>
      </ProductViewContainer>
    </>
  );
}
